<template>
  <div>
    <ts-page-title :title="$t('trialBalance.pageTitle')" :breadcrumb="[
      { text: $t('home'), href: '/' },
      {
        text: $t('trialBalance.pageTitle'),
        active: true
      }
    ]" />
    <ts-panel>
      <ts-panel-wrapper>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <ts-card>
                <ts-loading-banner :loading="loading">
                  <form>
                    <fieldset>
                      <legend>{{ $t('trialBalance.criteria') }}</legend>
                      <div class="mb-3 mt-3">
                            <label class="form-col-label control-label required">
                                {{ $t( "trialBalance.classifiedBy") }}
                            </label>
                            <br />
                            <RadioGroup v-model="model.classified_by"
                                size="small">
                                <Radio class="mt-1" :label="c.value" border
                                    v-for="(c, index) in classified" :key="index">
                                    {{ c.label }}
                                </Radio>
                            </RadioGroup>
                            <div class="text-danger" v-if="errors.has('classified_by')">
                                {{ errors.first("classified_by") }}
                            </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-12">
                          <label class="form-col-label control-label">{{
                            $t('trialBalance.branch')
                          }}</label>
                        </div>
                        <div class="col-md-12">
                          <ts-branch-filter @filter="value => (model.branch_id = value)" :isPlaceholder="true"
                            style="width: 100%" />
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-12">
                          <label class="form-col-label control-label required">{{ $t('trialBalance.asOfDate') }}</label>
                          <DatePicker v-model="model.as_of_date" placement="bottom-end" style="width: 100%"
                            :transfer="true" format="dd-MM-yyyy" @on-change="onChangeTransactionDate"></DatePicker>
                          <div class="text-danger" v-if="errors.has('as_of_date')">
                            {{ errors.first('as_of_date') }}
                          </div>
                        </div>
                      </div>
                      <div class="mt-4 mb-2">
                          <Checkbox v-model="model.is_all_currencies_consolidate">All currencies consolidate
                          </Checkbox>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-12">
                          <label class="form-col-label control-label required">{{ $t('trialBalance.currency')
                          }}</label><br />
                          <RadioGroup v-model="model.currency_id" size="small">
                            <Radio class="mt-1" :label="c.currency_id" border v-for="(c, index) in currencies"
                              :key="index">
                              {{ c.currency_code }}
                            </Radio>
                          </RadioGroup>
                          <div class="text-danger" v-if="errors.has('currency_id')">
                            {{ errors.first('currency_id') }}
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-12">
                          <label class="form-label col-label">{{
                            $t('trialBalance.excelTeplate')
                          }}</label>
                        </div>
                        <div class="col-md-12">
                          <RadioGroup v-model="model.excel_template">
                            <Radio class="mt-1" :label="c.value" border v-for="(c, index) in excelTeplate"
                              :key="index">{{ c.label }}
                            </Radio>
                          </RadioGroup>
                        </div>
                      </div>
                      <div class="mb-3 ts-justify-end ts-flex ts-space-x-2">
                        <ts-button outline color="success" @click.prevent="exportExcel" :waiting="exporting">
                          <i class="far fa-file-excel" v-if="!exporting"></i>
                          {{ $t('exportExcel') }}</ts-button>
                        <ts-button color="danger" outline @click.prevent="preview" :waiting="waiting">
                          <i class="far fa-file-pdf" v-if="!waiting"></i>
                          {{ $t('previewPdf') }}</ts-button>
                      </div>
                    </fieldset>
                  </form>
                </ts-loading-banner>
              </ts-card>
            </div>
          </div>
          <div class="col-lg-9">
            <div id="container">
              <ts-preview-pdf v-model="waiting" :src="src" />
            </div>
          </div>
        </div>
      </ts-panel-wrapper>
    </ts-panel>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
export default {
  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      coaSetupLoading: false,
      coaSetups: [],
      errors: new Errors(),
      src: '',
      excelTeplate: [
        {
          value: 'standard',
          label: 'Standard'
        },
        {
          value: 'raw-data',
          label: 'Raw Data'
        }
      ],
      classified: [
          {
              value: 'summary',
              label: 'Summary'
          },
          {
              value: 'branch',
              label: 'Branch'
          },
      ],
      model: {
        excel_template: 'standard',
        classified_by: 'summary',
        branch_id: [],
        currency_id: null,
        is_all_currencies_consolidate: false,
        as_of_date: moment().format('DD-MM-YYYY')
      }
    }
  },
  computed: {
    ...mapState('report/resource', ['currencies'])
  },
  created() {
    this.model.currency_id = this.$store.state.authUser.sys_setting.currency_id_from;
  },
  methods: {
    ...mapActions('report/resource', ['getCurrency']),
    preview() {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/accounting/trialBalance', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.errors = new Errors()
      this.exporting = true

      this.$store
        .dispatch('report/accounting/trialBalanceExportExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.notice({ type: 'error', text: error.message })
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    onChangeTransactionDate(date) {
      this.model.as_of_date = date
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'TRIAL BALANCE',
        desc: not.text
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getCurrency()
    })
  }
}
</script>
